const changePasswordSuccess = {
  'Ahora podés ingresar a tu cuenta': 'Ahora podés ingresar a tu cuenta.',
}

export default changePasswordSuccess
